import { render } from "./BookingYourReservation.vue?vue&type=template&id=47e5bc83"
import script from "./BookingYourReservation.vue?vue&type=script&lang=js"
export * from "./BookingYourReservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingYourReservation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47e5bc83"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47e5bc83', __exports__)) {
    api.reload('47e5bc83', __exports__)
  }
  
  module.hot.accept("./BookingYourReservation.vue?vue&type=template&id=47e5bc83", () => {
    api.rerender('47e5bc83', render)
  })

}


export default __exports__